"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../../Utilities");
var ShimmerElementsGroup_base_1 = require("./ShimmerElementsGroup.base");
var ShimmerElementsGroup_styles_1 = require("./ShimmerElementsGroup.styles");
exports.ShimmerElementsGroup = Utilities_1.styled(ShimmerElementsGroup_base_1.ShimmerElementsGroupBase, ShimmerElementsGroup_styles_1.getStyles);
//# sourceMappingURL=ShimmerElementsGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Shimmer/ShimmerElementsGroup/ShimmerElementsGroup.js
// module id = 828
// module chunks = 0